import React, { Suspense } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import Loader from "../components/Loader/Loader";
import useAuth from "../context/AuthContext";
import InvestorDashboard from "../pages/Dashboard/Investor/InvestorDashboard";
import MentorDashboard from "../pages/Dashboard/Mentor/MentorDashboard";
import ForgotPassword from "../pages/ForgotPassword";

import InvestorEdit from "../pages/InvestorEdit";
import InvestorDetailPage from "../pages/InvestorProfileDetail";
import InvestorsPage from "../pages/InvestorsPage";
import JobDetails from "../pages/JobDetails";
import MentorEdit from "../pages/MentorEdit";
import OyeGraduates from "../pages/Oye/OyeGraduates";

const GreenCircularPage = React.lazy(() =>
  import("../pages/About/GreenCircularPage")
);
const GreenProject = React.lazy(() => import("../pages/About/GreenProject"));
const FormApplication = React.lazy(() =>
  import("../pages/Applications/AccelerationApplication")
);
const AuthPage = React.lazy(() => import("../pages/AuthPage"));
const ConsentPage = React.lazy(() => import("../pages/ConsentPage"));
const Mentoring = React.lazy(() => import("../pages/Mentoring"));
const MentorDetailPage = React.lazy(() => import("../pages/MentorDetailPage"));

const ContactPage = React.lazy(() => import("../pages/Contact/ContactPage"));
const EventDetailPage = React.lazy(() => import("../pages/EventDetailPage"));
const EventsPage = React.lazy(() => import("../pages/EventsPage"));
const Homepage = React.lazy(() => import("../pages/Homepage"));
const IncubationPage = React.lazy(() =>
  import("../pages/Incubation/IncubationPage")
);
const JobsPage = React.lazy(() => import("../pages/JobsPage"));
const NewsDetailPage = React.lazy(() => import("../pages/NewsDetailPage"));
const NewsPage = React.lazy(() => import("../pages/NewsPage"));
const OyePage = React.lazy(() => import("../pages/Oye/OyePage"));
const Page404 = React.lazy(() => import("../pages/Page404"));
const ResourcesPage = React.lazy(() =>
  import("../pages/Resources/ResourcesPage")
);
const MentorsPage = React.lazy(() => import("../pages/MentorsPage"));
const UserDashboard = React.lazy(() =>
  import("../pages/Dashboard/UserDashboard")
);
const CreateProfilePage = React.lazy(() =>
  import("../pages/CreateProfilePage")
);
const CreateBusinessPage = React.lazy(() =>
  import("../pages/CreateBusinessPage")
);
const BusinessPage = React.lazy(() => import("../pages/BusinessPage"));
const OyeApplication = React.lazy(() =>
  import("../pages/Applications/OyeApplication")
);
const BusinessDetailPage = React.lazy(() =>
  import("../pages/BusinessDetailPage")
);

const GreenBusiness = React.lazy(() => import("../pages/GreenBusiness"));
const GreenEmployers = React.lazy(() => import("../pages/GreenEmployers"));
const FAQPage = React.lazy(() => import("../pages/FAQPage"));

export const MainNavigator = () => {
  const {
    state: { isAuthenticated, user },
  } = useAuth();

  let RoleDashboard = null;

  if (user && user.role === "investor") {
    RoleDashboard = InvestorDashboard;
  } else if (user && user.role === "mentor") {
    RoleDashboard = MentorDashboard;
  } else RoleDashboard = UserDashboard;

  const openRoutes = (
    <Suspense fallback={<Loader />}>
      <Switch>
        <Route path="/" component={Homepage} exact />
        <Route path="/auth" component={AuthPage} />
        <Route path="/forgot-password" component={ForgotPassword} />
        <Route path="/consent" component={ConsentPage} />
        <Route path="/contact-us" component={ContactPage} />
        <Route path="/mentoring" component={Mentoring} />
        <Route path="/business" component={BusinessPage} exact />

        <Route path="/business/:id" component={BusinessDetailPage} />

        <Route path="/green-and-circular" component={GreenCircularPage} />
        <Route path="/green-project" component={GreenProject} />
        <Route path="/green-business" component={GreenBusiness} />
        <Route path="/green-employers" component={GreenEmployers} />
        <Route path="/oye-graduates" component={OyeGraduates} />

        <Route path="/about-oye" component={OyePage} />
        <Route path="/incubation-and-acceleration" component={IncubationPage} />
        <Route path="/resources" component={ResourcesPage} />
        <Route path="/news" component={NewsPage} exact />
        <Route path="/faq" component={FAQPage} exact />

        <Route path="/jobs" component={JobsPage} exact />
        <Route path="/jobs/:slug" component={JobDetails} />
        <Route path="/mentor/update-profile" component={MentorEdit} />
        <Route path="/mentors" component={MentorsPage} exact />
        <Route path="/mentors/:id" component={MentorDetailPage} exact />

        <Route path="/investors" component={InvestorsPage} exact />
        <Route path="/investors/:id" component={InvestorDetailPage} />

        <Route path="/investor/update-profile" component={InvestorEdit} />

        <Route path="/events" component={EventsPage} />
        {/* <Route path='/page-under-development' component={Page404} /> */}
        <Route path="/event/:slug" component={EventDetailPage} />
        <Route path="/news/:slug" component={NewsDetailPage} />
        <Route path="/page-under-development" component={Page404} />
        <Redirect to={!isAuthenticated ? "/auth" : "/page-under-development"} />
      </Switch>
    </Suspense>
  );
  const authRoutes = (
    <Suspense fallback={<Loader />}>
      <Switch>
        <Route path="/" component={Homepage} exact />
        <Route path="/auth" component={AuthPage} />
        <Route path="/forgot-password" component={ForgotPassword} />
        <Route path="/consent" component={ConsentPage} />
        <Route path="/contact-us" component={ContactPage} />
        <Route path="/mentoring" component={Mentoring} />
        <Route path="/green-and-circular" component={GreenCircularPage} />
        <Route path="/green-project" component={GreenProject} />
        <Route path="/green-business" component={GreenBusiness} />
        <Route path="/green-employers" component={GreenEmployers} />
        <Route path="/oye-graduates" component={OyeGraduates} />

        <Route path="/about-oye" component={OyePage} />
        <Route path="/dashboard" component={RoleDashboard} />
        <Route
          path="/application-forms/:id"
          component={FormApplication}
          exact
        />

        <Route path="/incubation-and-acceleration" component={IncubationPage} />
        <Route path="/resources" component={ResourcesPage} />
        <Route path="/faq" component={FAQPage} exact />

        <Route path="/news" component={NewsPage} exact />
        <Route path="/news/:slug" component={NewsDetailPage} />
        <Route path="/jobs" component={JobsPage} exact />
        <Route path="/jobs/:slug" component={JobDetails} />

        <Route path="/mentors" component={MentorsPage} exact />
        <Route path="/mentors/:id" component={MentorDetailPage} />
        <Route path="/mentor/update-profile" component={MentorEdit} />

        <Route path="/investors" component={InvestorsPage} exact />
        <Route path="/investors/:id" component={InvestorDetailPage} />
        <Route path="/investor/update-profile" component={InvestorEdit} />

        <Route path="/create-profile" component={CreateProfilePage}></Route>
        <Route path="/create-business" component={CreateBusinessPage} />
        <Route path="/business" component={BusinessPage} exact />
        <Route path="/business/:id" component={BusinessDetailPage} />
        <Route path="/events" component={EventsPage} />
        <Route path="/event/:slug" component={EventDetailPage} />
        <Route path="/oye-application-forms/:id" component={OyeApplication} />
        {/* <Route
        path='/incu-application-forms/:id'
        component={IncubationApplication}
      /> */}
        <Route path="/page-under-development" component={Page404} />
        <Redirect to={"/page-under-development"} />
      </Switch>
    </Suspense>
  );

  return <div>{isAuthenticated ? authRoutes : openRoutes}</div>;
};
